import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu, Sparkles } from "lucide-react";
import { AdminSidebar } from "./admin-sidebar";

export function MobileAdminShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (drawerOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [drawerOpen]);

  return (
    <div className="flex h-[100dvh] w-screen flex-col overflow-hidden bg-background">
      <header className="flex h-12 shrink-0 items-center gap-2 border-b border-border bg-background px-3">
        <button
          type="button"
          onClick={() => setDrawerOpen(true)}
          aria-label="Open navigation"
          className="flex h-9 w-9 items-center justify-center rounded-md text-text-secondary hover:bg-surface-hover hover:text-text-primary"
        >
          <Menu size={20} />
        </button>
        <Sparkles size={18} className="text-accent" />
        <span className="text-base font-semibold text-text-primary">ProClaw</span>
        <span className="ml-auto rounded bg-accent/10 px-1.5 py-0.5 text-[10px] font-medium tracking-wide text-accent">
          MSP
        </span>
      </header>

      <main className="flex-1 min-w-0 min-h-0 overflow-y-auto">
        <Outlet />
      </main>

      {drawerOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/50"
            onClick={() => setDrawerOpen(false)}
          />
          <div className="fixed inset-y-0 left-0 z-50 flex w-[85vw] max-w-[320px] animate-in slide-in-from-left">
            <AdminSidebar />
          </div>
        </>
      )}
    </div>
  );
}
